import { parse } from "date-fns";

import { EmailDomainStatus, IEmailDomain } from "store/entities/email-domains/interfaces";

const statusMap = {
  new: EmailDomainStatus.New,
  pendingVerification: EmailDomainStatus.PendingVerification,
  active: EmailDomainStatus.Active,
  pendingDeletion: EmailDomainStatus.PendingDeletion,
  pendingConfiguration: EmailDomainStatus.PendingConfiguration,
  setupFailed: EmailDomainStatus.SetupFailed,
};

export default abstract class EmailDomainSerializer {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserialize(data: { [key: string]: any }): IEmailDomain {
    const deserialized: IEmailDomain = {
      id: data.ID,
      name: data.name,
      domain: `support@${data.name}`,
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      status: statusMap[data.status],
      flags: data.flags,
      createdAt: parse(data.createdAt),
      createdBy: data.createdBy,
      updatedAt: parse(data.updatedAt),
      updatedBy: data.updatedBy,
      dns: data.dns,
    };
    return deserialized;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserializeList(list: any): IEmailDomain[] {
    return list.map(EmailDomainSerializer.deserialize);
  }
}
